// 0x1F1E6 (regional indicator "A") minus the char code of "A" (65).
const FLAG_CODE_POINT_OFFSET = 127397;

// Converts an ISO2 country code into its Unicode flag emoji — no assets, no deps.
export const getFlagEmoji = (iso2: string): string =>
  iso2
    .toUpperCase()
    .replace(/[A-Z]/g, (char) =>
      String.fromCodePoint(FLAG_CODE_POINT_OFFSET + char.charCodeAt(0)),
    );
